<br><br><br>
<div class="page-title">
  <h1 class="title-text">Computer Request Form</h1>
</div>

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <!-- Progress Tracker -->
    <mat-progress-bar mode="determinate" [value]="calculateProgress()"></mat-progress-bar>
    <div class="progress-status" style="display: flex; justify-content: space-between; margin-top: 16px;">
      <div style="text-align: center; width: 100%;">
        Employee
        <br />
        @if (form.value?.section1.employeeCompleted) {
          <span style="color: green;">Completed</span>
        }
        @if (!form.value?.section1.employeeCompleted) {
          <span style="color: gray;">Pending</span>
        }
      </div>
      <div style="text-align: center; width: 100%;">
        Supervisor
        <br />
        @if (form.value?.section2.supervisorCompleted === true) {
          <span style="color: green;">Completed</span>
        }
        @if (form.value?.section2.supervisorCompleted === false) {
          <span style="color: gray;">Pending</span>
        }
      </div>
      <div style="text-align: center; width: 100%;">
        Operations Manager
        <br />
        @if (form.value?.section3.opsManagerCompleted === true) {
          <span style="color: green;">Completed</span>
        }
        @if (form.value?.section3.opsManagerCompleted === false) {
          <span style="color: gray;">Pending</span>
        }
      </div>
      <div style="text-align: center; width: 100%;">
        Technical Director
        <br />
        @if (form.value?.section4.techDirectorCompleted === true) {
          <span style="color: green;">Completed</span>
        }
        @if (form.value?.section4.techDirectorCompleted === false) {
          <span style="color: gray;">Pending</span>
        }
      </div>
    </div>

    <div class="sections">
      <mat-accordion multi="true">
        <!-- Section 1: Equipment Request Data -->
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Employee Request
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="form" (ngSubmit)="saveSection1()">
            <!-- Read-Only Mode -->
            @if (form.value?.section1.employeeCompleted) {
              <p>Request Date: <span class="readonly">{{ form.value?.section1.requestDate || 'N/A' }}</span></p>
              <p>Employee Name: <span class="readonly">{{ form.value?.section1.employeeName || 'N/A' }}</span></p>
              <p>Employee Email: <span class="readonly">{{ form.value?.section1.employeeEmail || 'N/A' }}</span></p>
              <p>Job Title: <span class="readonly">{{ form.value?.section1.jobTitle || 'N/A' }}</span></p>
              <p>Department: <span class="readonly">{{ form.value?.section1.department || 'N/A' }}</span></p>
              <p>Reporting Office: <span class="readonly">{{ form.value?.section1.reportingOffice || 'N/A' }}</span></p>
              <p>Supervisor: <span class="readonly">{{ form.value?.section1.supervisor || 'N/A' }}</span></p>
              <p>Supervisor Email: <span class="readonly">{{ form.value?.section1.supervisorEmail || 'N/A' }}</span></p>
              <p>Operations Manager: <span class="readonly">{{ form.value?.section1.operationsManager || 'N/A' }}</span></p>
              <p>Operations Manager Email: <span class="readonly">{{ form.value?.section1.operationsManagerEmail || 'N/A' }}</span></p>
              <p>Reason for Request: <span class="readonly">{{ form.value?.section1.reasonForRequest || 'N/A' }}</span></p>
              <p>Current Computer Type: <span class="readonly">{{ form.value?.section1.currentComputerType || 'N/A' }}</span></p>
              <p>Requested Computer Type: <span class="readonly">{{ form.value?.section1.requestedComputerType || 'N/A' }}</span></p>
              <p>Current Edition: <span class="readonly">{{ form.value?.section1.currentEdition || 'N/A' }}</span></p>
              <p>Current Processor: <span class="readonly">{{ form.value?.section1.currentProcessor || 'N/A' }}</span></p>
              <p>Current Installed Ram: <span class="readonly">{{ form.value?.section1.currentInstalledRam || 'N/A' }}</span></p>
              <p>Current Storage: <span class="readonly">{{ form.value?.section1.currentStorage || 'N/A' }}</span></p>
              <p>Current Graphics Card: <span class="readonly">{{ form.value?.section1.currentGraphicsCard || 'N/A' }}</span></p>
              <p>Requested Computer Spec: <span class="readonly">{{ form.value?.section1.requestedComputerSpecs || 'N/A' }}</span></p>
              <p>Other/Special Requests: <span class="readonly">{{ form.value?.section1.otherSpecialRequests || 'N/A' }}</span></p>
            } @else {
              <div formGroupName="section1">
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Request Date</mat-label>
                  <input matInput formControlName="requestDate" type="date">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Employee Name</mat-label>
                  <input matInput placeholder="Enter employee name" formControlName="employeeName">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Employee Email</mat-label>
                  <input matInput placeholder="Enter employee email" formControlName="employeeEmail">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Job Title</mat-label>
                  <input matInput placeholder="" formControlName="jobTitle">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Department</mat-label>
                  <input matInput placeholder="" formControlName="department">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Reporting Office</mat-label>
                  <input matInput placeholder="" formControlName="reportingOffice">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Supervisor</mat-label>
                  <input matInput placeholder="" formControlName="supervisor">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Supervisor Email</mat-label>
                  <input matInput placeholder="" formControlName="supervisorEmail">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Operations Manager</mat-label>
                  <mat-select formControlName="operationsManagerEmail" (selectionChange)="onOperationsManagerSelected($event.value)">
                    @for (manager of operationsManagers; track manager.email) {
                      <mat-option [value]="manager.email">{{ manager.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Reason for Request</mat-label>
                  <input matInput placeholder="" formControlName="reasonForRequest">
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Computer Type:</mat-label>
                  <mat-select formControlName="currentComputerType">
                    <mat-option value="Laptop">Laptop</mat-option>
                    <mat-option value="Desktop">Desktop</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Requested Computer Type:</mat-label>
                  <mat-select formControlName="requestedComputerType">
                    <mat-option value="Laptop">Laptop</mat-option>
                    <mat-option value="Desktop">Desktop</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-divider [vertical]="false"></mat-divider>
                <h2 class="title-text-sub">Current Computer Specifications</h2>
                <p>Please find your current computer specs and fill out the following fields below.</p>
                <ul>
                  <li>To find <b>Edition, Process, and Installed RAM</b> type “Settings” in the search pane then click “System.” Scroll to
                the bottom and select “About”</li>
                <br>
                  <li>To find the <b>graphics card</b> type “Device Manager” in the search pane. Select “Display Adapters”</li>
                  <br>
                    <li>To find <b>storage</b> type “Settings” in the search pane, then click “Storage.” The total storage space will be
                  shown at the top of the screen.</li>
                </ul>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Edition</mat-label>
                  <input matInput placeholder="" formControlName="currentEdition" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Processor</mat-label>
                  <input matInput placeholder="" formControlName="currentProcessor" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Installed Ram</mat-label>
                  <input matInput placeholder="" formControlName="currentInstalledRam" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Storage</mat-label>
                  <input matInput placeholder="" formControlName="currentStorage" />
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Current Graphics Card</mat-label>
                  <input matInput placeholder="" formControlName="currentGraphicsCard" />
                </mat-form-field>
                <mat-divider [vertical]="false"></mat-divider>
                <h2 class="title-text-sub">Computer Spec Descriptions</h2>
                <p>Please review the following options and select your requested configuration in the drop-down menu below.</p>
                <b>Travel - Exec Team/BD/Aerial Field (Not using TBC or Civil 3D)</b>
                <ul>
                  <li>Lightweight</li>
                  <li>12th Gen i7</li>
                  <li>32GB memory</li>
                  <li>500GB hard drive</li>
                  <li>Software: Adobe or Bluebeam</li>
                </ul>
                <b>Admins (Not using TBC or Civil 3D)</b>
                <ul>
                  <li>12th Gen i7</li>
                  <li>32GB memory</li>
                  <li>500GB hard drive</li>
                  <li>Software: Adobe or Bluebeam</li>
                </ul>
                <b>Survey Techs</b>
                <ul>
                  <li>13th or 14th Gen i7/i9</li>
                  <li>32GB memory</li>
                  <li>500GB hard drive</li>
                  <li>8GB Nvidia GPU</li>
                  <li>Software: Adobe or Bluebeam, Autodesk Civil 3D, TBC, Google Earth</li>
                </ul>
                <b>Survey Techs that do Lidar processing</b>
                <ul>
                  <li>13th or 14th Gen i7/i9</li>
                  <li>32GB memory</li>
                  <li>1TB hard drive</li>
                  <li>8GB Nvidia GPU</li>
                  <li>Software: Adobe or Bluebeam, Autodesk Civil 3D, TBC, Google Earth</li>
                </ul>
                <b>GIS/Geospatial Techs</b>
                <ul>
                  <li>13th or 14th Gen (or newer) i7/i9</li>
                  <li>64GB memory</li>
                  <li>1TB for OS and software</li>
                  <li>1TB or more for storage if needed</li>
                  <li>8GB Nvidia GPU</li>
                  <li>Software: Adobe or Bluebeam, Google Earth</li>
                </ul>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Requested Computer Specs:</mat-label>
                  <mat-select matInput placeholder="" formControlName="requestedComputerSpecs">
                    <mat-option value="Travel">Travel</mat-option>
                    <mat-option value="Admin">Admin</mat-option>
                    <mat-option value="Survey Tech">Survey Tech</mat-option>
                    <mat-option value="Survey Tech with Lidar">Survey Tech with Lidar</mat-option>
                    <mat-option value="GIS/Geospatial Tech">GIS/Geospatial Tech</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-divider [vertical]="false"></mat-divider>
                <br><br>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Other/Special Requests</mat-label>
                  <textarea matInput formControlName="otherSpecialRequests" rows="5"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Employee Signature</mat-label>
                  <input matInput placeholder="" formControlName="employeeSignature" />
                </mat-form-field>
                <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Submit Request</button>
                @if (loadingSection1) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
                @if (!loadingSection1 && form.invalid && form.touched) {
                  <div class="error-message">
                    Please fill in all required fields.
                  </div>
                }
                <br>
                  @if (form.get('section1.supervisorEmail')?.touched && form.get('section1.supervisorEmail')?.hasError('email')) {
                    <div class="error-message">
                      Please enter a valid email address for the supervisor.
                    </div>
                  }
                  <br><br>
                </div>
              }

              <!-- Editable Mode -->
            </form>
          </mat-expansion-panel>

          <!-- Section 2: Supervisor Signature -->
          <mat-expansion-panel [expanded]="currentStep === 2">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Supervisor Signature
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="form" (ngSubmit)="saveSection2()">
              <!-- Read-Only Mode -->
              @if (form.value?.section2.supervisorCompleted || !form.value?.section1.employeeCompleted) {
                <p>Supervisor Signature: <span class="readonly">{{ form.value?.section2.supervisorSignature || 'N/A' }}</span></p>
                <p>Date: <span class="readonly">{{ form.value?.section2.supervisorSignedDate || 'N/A' }}</span></p>
              } @else {
                <div formGroupName="section2">
                  <mat-radio-group formControlName="supervisorApproval" class="mat-radio-group-vertical">
                    <mat-radio-button [value]="true">I approve the above computer request.</mat-radio-button>
                    <mat-radio-button [value]="false">I reject the above computer request.</mat-radio-button>
                  </mat-radio-group>
                  @if (form.get('section2.supervisorApproval')?.value === false) {
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Rejection Reason</mat-label>
                      <textarea matInput formControlName="supervisorRejectionReason" rows="5"></textarea>
                    </mat-form-field>
                  }
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Supervisor Signature</mat-label>
                    <input matInput placeholder="" formControlName="supervisorSignature" />
                  </mat-form-field>
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Date</mat-label>
                    <input matInput placeholder="" formControlName="supervisorSignedDate" type="date" />
                  </mat-form-field>
                  <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Complete Section</button>
                  @if (loadingSection2) {
                    <div class="loading-spinner">
                      <mat-spinner diameter="30"></mat-spinner>
                    </div>
                  }
                </div>
              }

              <!-- Editable Mode -->
            </form>
          </mat-expansion-panel>

          <!-- Section 3: Operations Manager Signature -->
          <mat-expansion-panel [expanded]="currentStep === 3">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Operations Manager Signature
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="form" (ngSubmit)="saveSection3()">
              <!-- Read-Only Mode -->
              @if (form.value?.section3.opsManagerCompleted || !form.value?.section2.supervisorCompleted) {
                <p>Operations Manager Signature: <span class="readonly">{{ form.value?.section3.opsManagerSignature || 'N/A' }}</span></p>
                <p>Date: <span class="readonly">{{ form.value?.section3.opsManagerSignedDate || 'N/A' }}</span></p>
              } @else {
                <div formGroupName="section3">
                  <mat-radio-group formControlName="opsManagerApproval" class="mat-radio-group-vertical">
                    <mat-radio-button [value]="true">I approve the above computer request.</mat-radio-button>
                    <mat-radio-button [value]="false">I reject the above computer request.</mat-radio-button>
                  </mat-radio-group>
                  @if (form.get('section3.opsManagerApproval')?.value === false) {
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Rejection Reason</mat-label>
                      <textarea matInput formControlName="opsManagerRejectionReason" rows="5"></textarea>
                    </mat-form-field>
                  }
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Operations Manager Signature</mat-label>
                    <input matInput placeholder="" formControlName="opsManagerSignature" />
                  </mat-form-field>
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Date</mat-label>
                    <input matInput placeholder="" formControlName="opsManagerSignedDate" type="date" />
                  </mat-form-field>
                  <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Complete Section</button>
                  @if (loadingSection3) {
                    <div class="loading-spinner">
                      <mat-spinner diameter="30"></mat-spinner>
                    </div>
                  }
                </div>
              }

              <!-- Editable Mode -->
            </form>
          </mat-expansion-panel>

          <!-- Section 4: Technical Director Signature -->
          <mat-expansion-panel [expanded]="currentStep === 4">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Technical Director Signature
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="form" (ngSubmit)="saveSection4()">
              <!-- Read-Only Mode -->
              @if (form.value?.section4.techDirectorCompleted || !form.value?.section3.opsManagerCompleted) {
                <p>Technical Director Signature: <span class="readonly">{{ form.value?.section4.techDirectorSignature || 'N/A' }}</span></p>
                <p>Date: <span class="readonly">{{ form.value?.section4.techDirectorSignedDate || 'N/A' }}</span></p>
              } @else {
                <div formGroupName="section4">
                  <mat-radio-group formControlName="techDirectorApproval" class="mat-radio-group-vertical">
                    <mat-radio-button [value]="true">I approve the above computer request.</mat-radio-button>
                    <mat-radio-button [value]="false">I reject the above computer request.</mat-radio-button>
                  </mat-radio-group>
                  @if (form.get('section4.techDirectorApproval')?.value === false) {
                    <mat-form-field appearance="fill" style="width: 100%;">
                      <mat-label>Rejection Reason</mat-label>
                      <textarea matInput formControlName="techDirectorRejectionReason" rows="5"></textarea>
                    </mat-form-field>
                  }
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Technical Director Signature</mat-label>
                    <input matInput placeholder="" formControlName="techDirectorSignature" />
                  </mat-form-field>
                  <mat-form-field appearance="fill" style="width: 100%;">
                    <mat-label>Date</mat-label>
                    <input matInput placeholder="" formControlName="techDirectorSignedDate" type="date" />
                  </mat-form-field>
                  <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Complete Section</button>
                  @if (loadingSection4) {
                    <div class="loading-spinner">
                      <mat-spinner diameter="30"></mat-spinner>
                    </div>
                  }
                </div>
              }

              <!-- Editable Mode -->
            </form>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-card-content>
  </mat-card>
  <br><br>
